import globalConfig from '@utiles/officialStore/globalConfig';
import { getJSON, getJSONWithoutEntryParam } from './ultile';
import { UPDATE_LOADING } from './index';
import { gameIdTransform } from '@utiles/officialTopupNew/transform';
const gameId =
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParam('gameID') ||
  globalConfig.getHrefParam('game_id') ||
  '';

const isJpPlatform = +gameId === 2;
/**
 * 获取活动请求地址
 * @param {string[]} pos
 * 'index_banner' 主页banner | 'popup' 开屏破冰弹窗 | 'pay_banner' 结果页banner | 'lamp' 跑马灯公告 | 'time_award' 限时领奖活动 | 'hero_section' 金刚区;
 * @param {int} gameId
 * @param {string} lang
 * @returns
 */
const activityListUrl = isJpPlatform
  ? `//jpeventsapi.${globalConfig.getMainHost()}/activity_payment/list`
  : `//gactivityapi.${globalConfig.getMainHost()}/activity_payment/list`;

/**
 * 获取活动基础信息请求地址
 * @param {string} action
 * @param {string} name
 * @param {string} params
 * @returns
 */

const activityUrl = isJpPlatform
  ? `//jpeventsapi.${globalConfig.getMainHost()}/activity/execute`
  : `//gactivityapi.${globalConfig.getMainHost()}/activity/execute`;

export const GET_ACTIVITY_BASIC = 'GET_ACTIVITY_BASIC'; // 获取活动基础信息
// 列表
export const GET_ACTIVITY_LIST = 'GET_ACTIVITY_LIST'; // 获取活动列表信息
export const SET_ACTIVITY_LIST = 'SET_ACTIVITY_LIST'; // 设置活动列表信息
// 活动
export const GET_POPUP_BASIC = 'GET_POPUP_BASIC'; // 获取弹窗配置信息
export const GET_TIME_AWARD_BASIC = 'GET_TIME_AWARD_BASIC'; // 获取弹窗信息

export const FINISH_SHARE = 'FINISH_SHARE'; // 完成分享任务接口
export const FINISH_REDIRECT = 'FINISH_REDIRECT'; // 完成跳转任务接口
export const FINISH_SAVE_DESKTOP = 'FINISH_SAVE_DESKTOP'; // 完成保存到桌面任务接口
export const GET_TIME_AWARD = 'GET_TIME_AWARD'; // 领取限时任务奖励

export const SET_PWA_STATUS = 'SET_PWA_STATUS'; // 设置PWA状态

//展示类型：1纯展示类型、2发奖弹屏类型、3跳转链接类型
export const POPUP_TYPE = {
  SHOW: 1,
  AWARD: 2,
  REDIRECT: 3
};
//弹窗规则：1每次都弹、2完成领奖后不弹出、3首次访问弹出、4账号终身一次
export const POPUP_LIMIT_TYPE = {
  EVERY_TIME: 1,
  BEFORE_AWARD: 2,
  FIRST_VISIT: 3,
  ONCE: 4
};

// 任务类型：login登录任务、first_pay首笔储值、total_pay累计充值、share分享任务、redirect跳转链接
export const TIME_AWART_TYPE = {
  LOGIN: 'login',
  FIRST_PAY: 'first_pay',
  TOTAL_PAY: 'total_pay',
  SHARE: 'share',
  REDIRECT: 'redirect',
  SAVE_DESKTOP: 'save_desktop'
};

// 任务状态：0未完成、1已完成、2已领取
export const TIME_AWART_STATUS = {
  UNFINISHED: 0,
  FINISHED: 1,
  GOT: 2
};

// 跳转类型：1本页跳转、2新页跳转
export const JUMP_TYPE = {
  SELF: 1,
  BLANK: 2
};

export default {
  state: {
    showPwaInstall: true, // 是否展示PWA(手动关闭)

    popupList: [], //开屏弹窗
    indexBannerList: [], //主页banner
    payBannerList: [], //支付结果页banner
    lampList: [], //跑马灯公告
    timeAwardList: [], //限时领奖活动
    recommend: [], //推荐商品
    heroSection: [], //金刚区

    timer: null //限时活动倒计时
  },
  getters: {
    showTimeAwardList(state) {
      return state.timeAwardList.filter(item => item.basic?.countdown > 0);
    },
    hasSaveDesktopTask(state) {
      return state.timeAwardList.some(item => item.basic?.taskType === TIME_AWART_TYPE.SAVE_DESKTOP) || false;
    }
  },
  mutations: {
    // 设置活动列表信息，有则覆盖，无则不变
    [SET_ACTIVITY_LIST](state, list) {
      state.popupList = list.popup || state.popupList;
      state.indexBannerList = list.index_banner || state.indexBannerList;
      state.payBannerList = list.pay_banner || state.payBannerList;
      state.lampList = list.lamp || state.lampList;
      state.timeAwardList = list.time_award || state.timeAwardList;
      state.recommend = list.recommend || state.recommend;
      state.heroSection = list.hero_section || state.heroSection;
      // 设置限时活动的倒计时
      clearInterval(state.timer);
      state.timer = setInterval(() => {
        state.timeAwardList.forEach(item => {
          if (item.basic.countdown > 0) {
            item.basic.countdown -= 1;
          }
        });
      }, 1000);
    },
    [SET_PWA_STATUS](state, status) {
      state.showPwaInstall = status;
    }
  },
  actions: {
    // 获取活动列表信息
    [GET_ACTIVITY_LIST]({ rootState }, { pos }) {
      const posStr = pos?.length ? pos.join(',') : '';
      return getJSON(activityListUrl, gameIdTransform({
        pos: posStr,
        gameId: gameId,
        language: rootState.lang
      })).then(({ res }) => {
        if (+res.code === 1) {
          this.commit(SET_ACTIVITY_LIST, res.data);
        }
      });
    },
    // 获取活动基础信息
    [GET_ACTIVITY_BASIC]({ rootState }, name) {
      return getJSON(activityUrl, {
        name: name,
        action: 'basic',
        language: rootState.lang
      }).then(({ res }) => {
        return res;
      });
    },
    // 完成跳转任务
    [FINISH_REDIRECT](state, enname) {
      return getJSON(activityUrl, {
        name: enname,
        action: 'redirect'
      }).then(({ res }) => {
        return res;
      });
    },
    // 完成分享任务
    [FINISH_SHARE](state, enname) {
      return getJSON(activityUrl, {
        name: enname,
        action: 'share'
      }).then(({ res }) => {
        return res;
      });
    },
    // 完成保存到桌面限时任务
    [FINISH_SAVE_DESKTOP](state, enname) {
      return getJSON(activityUrl, {
        name: enname,
        action: 'saveDesktop'
      }).then(({ res }) => {
        return res;
      });
    },
    // 领取限时任务奖励
    [GET_TIME_AWARD]({ rootState }, params) {
      this.commit(UPDATE_LOADING, true);
      return getJSON(activityUrl, {
        name: params.name,
        action: 'award',
        params: JSON.stringify(params)
      }).then(({ res }) => {
        this.commit(UPDATE_LOADING, false);
        return res;
      });
    }
  }
};
